let _gPrefix = '';

function _getLogger(): Console {
  const logger: Console = {...console};
  const wrappedPrefix = `[${_gPrefix}]:`;
  // Iterate over the keys of the Console object

  // Bind the method to window.console and prepend the prefix
  logger.log = console.log.bind(window.console, wrappedPrefix);
  logger.info = console.info.bind(window.console, wrappedPrefix);
  logger.warn = console.warn.bind(window.console, wrappedPrefix);
  logger.error = console.error.bind(window.console, wrappedPrefix);
  logger.debug = console.debug.bind(window.console, wrappedPrefix);

  return logger as Console;
}

let logger = _getLogger();

function updateLoggerPrefix(prefix: string) {
  _gPrefix = prefix;
  logger = _getLogger();
}

function concatToLoggerPrefix(text: string): {previousPrefix: string; newPrefix: string} {
  const prevPrefix = _gPrefix;
  _gPrefix = `${_gPrefix}|${text}`;
  logger = _getLogger();

  return {previousPrefix: prevPrefix, newPrefix: _gPrefix};
}

export {logger, updateLoggerPrefix, concatToLoggerPrefix};
